import styled from "styled-components";

export const Wrapper = styled.div`
padding-left: 17px;
padding-right: 17px;
height: 100%;
`
export const TableTitle = styled.div`
width: 100%;
margin-top: 28px;
margin-bottom: 17px;
color: var(--font-color-blue002e5c);
font-size: var(--general-header-font-size);
font-style: normal;
font-weight: var(--general-header-font-weight);
line-height: 32px;
padding-top:10px;
span{
padding-right: 5px;
}
`
export const Cell = styled.div`
font-size: var(--general-caption-font-size);
color: var(--font-color-tableheader);
line-height: 32px;
display: flex;
align-items: center;
`

export const LedgerMobileView = styled.div`
color: var(--font-color-gray4f4f4f);
font-size: var(--general-body-font-size);
font-weight: var(--general-body-font-weight);
display: flex;
justify-content: space-between;
align-items: flex-start;
flex-direction: column;

`
export const Ledger = styled.span`
color: var(--font-color-gray4f4f4f);
font-size: var(--general-caption-font-size);
font-weight: var(--general-caption-font-weight);
display: block;

    width: 120px;

`
export const SubLedger = styled.span`
color: var(--font-color-gray4f4f4falpha60);
font-family: var(--general-caption-font-family);
font-size: var(--general-caption-font-size);
font-style: normal;
font-weight: var(--general-caption-font-weight);
line-height: normal;
display: block;

    width: 120px;

`
export const ContentCard = styled.div`
height: 85%;
overflow-y: auto;
`

export const DueDate = styled.div`
width: 100%;
color: var(--font-color-gray4f4f4f);
font-weight: var(--general-small-header-font-weight);
font-size: var(--general-small-header-font-size);
padding-left: 32px;
`

export const Ledgers = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
padding: 12px 10px;
margin-bottom: 12px;
`
export const LedgerGroup = styled.div`
    text-align: left;
    width: 100%;
    padding-left: 33px;

;`
export const Payment = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
height: 32px;
border-radius: 4px;
background: #F0F0F3;
padding-left: 20px;
padding-right: 20px;
margin-bottom: 30px;
span{
    font-size: var(--general-sub-header-font-size);
    font-weight: var(--general-sub-header-font-weight);

}
`
export const SelectAll = styled.div`
width: 100%;
display: flex;
justify-content: flex-start;
align-items: center;
color: var(--font-color-gray4f4f4f);
font-weight: var(--general-button-font-weight);
font-size: var(--general-button-font-size);
margin-bottom: 15px;
text-align: center;
span{
    padding-left: 8px;
    }
`
export const NoPayment = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 50%;
    color: var(--font-color-grayb5b5c3);
    font-style: normal;
    
    font-weight: var(--general-large-body-font-weight);
    font-size: var(--general-large-body-font-size);
`